// extracted by mini-css-extract-plugin
export var copyableField = "_qw-4";
export var customerBadge = "_qw-0";
export var customerInfoTitle = "_qw-2";
export var details = "_qw-1";
export var dropdownContainer = "_qw-5";
export var dropdownImage = "_qw-6";
export var editAssigneeForm = "_qw-a";
export var editButton = "_qw-3";
export var email = "_qw-7";
export var hidden = "_qw-d";
export var input = "_qw-8";
export var saveButton = "_qw-b";
export var shopifyIcon = "_qw-c";
export var suggestionBadge = "_qw-e";
export var suggestionText = "_qw-f";
export var username = "_qw-9";